import { isUserStaff, isUserAdmin } from "@jasper/shared";
import { useNavigate } from "react-router-dom";
import { IconSettings, IconLogout } from "@tabler/icons-react";
import { UseAuth } from "/@/contexts";
import { NavLink } from "./NavLink";
import { asUser } from "./helpers/navMenu";
import { useIsPathActive } from "./hooks/useIsPathActive";
import { getStaffLinks, getStaffAndAdminLinks } from "./helpers/navbarLinks";

export const StaffToolsMenu = () => {
  const { user, logOut } = UseAuth();
  const navigate = useNavigate();
  const isPathActive = useIsPathActive();

  const logOutFromLabs = async () => {
    if (await logOut()) {
      navigate("/");
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gap: "5px",
        flexShrink: 0,
      }}
    >
      <hr style={{ width: "100%" }} />
      {isUserStaff(asUser(user)) && (
        <>
          {getStaffLinks(user?.email).map(link => (
            <NavLink
              key={link.path}
              title={link.title}
              onClick={() => navigate(link.path)}
              active={isPathActive(link.path)}
              icon={link.icon}
            />
          ))}
          <hr style={{ width: "100%" }} />
          {getStaffAndAdminLinks().map(link => (
            <NavLink
              key={link.path}
              title={link.title}
              onClick={() => navigate(link.path)}
              active={isPathActive(link.path)}
              icon={link.icon}
            />
          ))}
          <hr style={{ width: "100%" }} />
        </>
      )}
      {isUserAdmin(asUser(user)) && (
        <NavLink
          title="Settings"
          onClick={() => navigate(`/settings`)}
          active={isPathActive("/settings")}
          icon={<IconSettings />}
        />
      )}
      <NavLink title="Log out" onClick={logOutFromLabs} icon={<IconLogout />} />
    </div>
  );
};
